import { createContext, useReducer, useCallback } from "react";
import UserReducer from "./UserReducer";
import { getUsers } from "./apiCalls"; // change path if needed

const INITIAL_STATE = {
    users: [],
    isFetching: false,
    error: false,
    hasFetched: false,
};

export const UserContext = createContext(INITIAL_STATE);

export const UserContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(UserReducer, INITIAL_STATE);

    const fetchUsers = useCallback(
        async (toast, forceRefresh = false) => {
            if (state.hasFetched && !forceRefresh) {
                return;
            }

            await getUsers(dispatch, toast);
        },
        [state.hasFetched]
    );

    return (
        <UserContext.Provider
            value={{
                users: state.users,
                isFetching: state.isFetching,
                error: state.error,
                hasFetched: state.hasFetched,
                dispatch,
                fetchUsers,
            }}
        >
            {children}
        </UserContext.Provider>
    );
};